import { render, staticRenderFns } from "./OHS.vue?vue&type=template&id=28e123f1&"
import script from "./OHS.vue?vue&type=script&lang=js&"
export * from "./OHS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports